// extracted by mini-css-extract-plugin
export default {"loaderFullScreen":"Loader_loaderFullScreen__RmERk","loader-big":"Loader_loader-big__r-xNb","loader":"Loader_loader__uy4ge"};